import * as React from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

import { IGroupEntriesProps } from '../types';

const GroupEntries: React.FC<IGroupEntriesProps> = ({
  groupId,
  items,
  hidden,
}) => (
  <Droppable droppableId={`group-${groupId}`} type="item">
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        className={`${hidden ? 'hidden' : ''} transition-shadow ${
          snapshot.isDraggingOver ? 'shadow-md' : ''
        }`}
      >
        {items.length > 0 ? (
          items.map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={`item-${String(item.id)}`}
              index={index}
            >
              {(provided2, snapshot2) => (
                <div
                  ref={provided2.innerRef}
                  {...provided2.draggableProps}
                  {...provided2.dragHandleProps}
                  className={`px-4 py-2 mb-1 transition-bgcolor ${
                    snapshot2.isDragging ? 'bg-green' : 'bg-white'
                  }`}
                >
                  {item.name}
                </div>
              )}
            </Draggable>
          ))
        ) : (
          <p className="bg-white py-2 px-3">
            <em>No items yet, drop here to add</em>
          </p>
        )}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
);

export default GroupEntries;



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/components/GroupEntries.tsx